import { Link as RouterLink, useParams } from 'react-router-dom';
import { Trans } from '@lingui/macro';
import { IconArrowLeft } from '@tabler/icons-react';
import { Box } from '~/design-system';
import ImportsOverview, {
  useImportsOverview,
} from '../../components/ImportsOverview/ImportsOverview';
import Layout from '../../components/Layout/Layout';

export default function ImportsHistoryPage() {
  const { workspaceId } = useParams();
  const props = useImportsOverview({ workspaceId });
  return (
    <Layout>
      <Box
        sx={{
          maxWidth: 900,
          margin: '0 auto',
          paddingX: 3,
          // Layout sets textAlign: center on its inner Box; override here so
          // the back link sits flush-left rather than centred under the page.
          textAlign: 'left',
          marginBottom: 3,
        }}
      >
        <Box
          as={RouterLink}
          // @ts-ignore - react-router-dom 'to' prop isn't on Box typing
          to={`/${workspaceId}`}
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 1,
            fontSize: '13px',
            color: '#6b7280',
            textDecoration: 'none',
            '&:hover': { color: '#2563eb' },
          }}
        >
          <IconArrowLeft size={14} stroke={1.75} />
          <Trans>Back to import picker</Trans>
        </Box>
      </Box>
      <ImportsOverview {...props} />
    </Layout>
  );
}
